export default "__VITE_ASSET__CCGanm0a__"